var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 165,
    viewBox: "0 0 108 165",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.127751 165C0.127751 154.927 -0.127871 146.893 0.255561 138.86C0.383372 136.82 2.42834 134.525 4.21769 133.122C24.923 117.438 45.7562 102.009 66.4615 86.3253C67.9952 85.1777 69.2733 83.9026 71.1905 82.1175C60.0709 73.7017 49.4627 65.6685 38.7266 57.7628C27.3514 49.2195 15.7206 40.9312 4.60112 32.1329C2.30053 30.3478 0.638993 26.7774 0.383372 23.8447C-0.255681 16.3215 0.127751 8.92581 0.127751 0C36.5538 27.7975 71.9573 54.83 108 82.5C72.213 109.915 36.8094 136.947 0.127751 165Z",
    fill: "white",
    fillOpacity: 0.21
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 165,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.3ee2e13fe8eff50b1a77d0ac36fd488c.svg";
export { ForwardRef as ReactComponent };